import { useMemo, useEffect } from 'react';
import { Button, Typography } from 'antd';
import { CloseOutlined, PartitionOutlined } from '@ant-design/icons';
import { useSankey } from '../../contexts/SankeyContext';
import { useData } from '../../contexts/DataContext';
import { filterTripsByDateTime } from '../../utils/dataTransform';
import SankeyDiagram from './SankeyDiagram';
import SankeySidebar from './SankeySidebar';
import './styles.css';

const { Title } = Typography;

const SankeyView = () => {
  const { percentageData, timeSlots } = useData();
  const {
    isOpen,
    closeSankey,
    dayType,
    timeSlot,
    setTimeSlot,
    selectedOrigins,
    selectedDestinations,
    minFlowLimit,
  } = useSankey();

  // Auto-select first time slot when opening if none selected
  useEffect(() => {
    if (isOpen && !timeSlot && timeSlots.length > 0) {
      const defaultSlot = timeSlots.find(s => s !== 'Tutto il giorno') || timeSlots[0];
      setTimeSlot(defaultSlot);
    }
  }, [isOpen, timeSlot, timeSlots, setTimeSlot]);

  // Get filtered trips based on day type and time slot
  const filteredTrips = useMemo(() => {
    if (!percentageData || !dayType || !timeSlot) {
      return [];
    }
    return filterTripsByDateTime(percentageData, dayType, timeSlot);
  }, [percentageData, dayType, timeSlot]);

  // Filter options for Sankey diagram
  const filters = useMemo(
    () => ({
      minFlow: minFlowLimit,
      origins: selectedOrigins,
      destinations: selectedDestinations,
    }),
    [minFlowLimit, selectedOrigins, selectedDestinations]
  );

  if (!isOpen) {
    return null;
  }

  return (
    <div className="sankey-view">
      {/* Header */}
      <div className="sankey-header">
        <div className="sankey-header-title">
          <PartitionOutlined style={{ fontSize: 24, color: '#1a4c3a' }} />
          <Title level={4}>Diagramma Sankey - Flussi OD</Title>
        </div>
        <div className="sankey-header-actions">
          <Button
            icon={<CloseOutlined />}
            onClick={closeSankey}
            className="sankey-close-btn"
          />
        </div>
      </div>

      {/* Body */}
      <div className="sankey-body">
        {/* Sidebar */}
        <SankeySidebar />

        {/* Diagram area */}
        <div className="sankey-diagram-area">
          <SankeyDiagram trips={filteredTrips} filters={filters} />
        </div>
      </div>
    </div>
  );
};

export default SankeyView;
